import { useInfiniteQuery } from '@tanstack/react-query';
import { useInterval } from 'usehooks-ts';

import { PublicApiLog } from '@/models/Log';
import { PublicApiLogResponse } from '@/models/network';
import { publicApi } from '@/utils/api';

const usePollingLogChunks = ({ url, queryKey, enabled }: { url: string; queryKey: unknown[]; enabled: boolean }) => {
  const query = useInfiniteQuery({
    queryKey,
    initialPageParam: '',
    enabled,
    queryFn: ({ pageParam }) =>
      publicApi.get<PublicApiLogResponse<PublicApiLog[]>>(url, {
        params: { after_timestamp: pageParam },
      }),
    select(data) {
      const chunks: string[] = [];
      data.pages.forEach((page) =>
        page.data.logChunks.forEach((part) => {
          chunks[part.position] = part.chunk;
        }),
      );
      return chunks.join('');
    },
    getNextPageParam(data) {
      return data.data.nextAfterTimestamp;
    },
  });
  useInterval(() => query.fetchNextPage(), enabled ? 5000 : null);
  return query.data;
};

export default usePollingLogChunks;
